import { useMemo } from 'react';

import { PersonType } from '@/../../backend/src/types/types';
import { capitalizeFirstLetter } from '@/helpers/filterNames';
import { FilterPopoverContent } from '@/new/components/filter-popover-content';
import {
  MultiSelect,
  MultiSelectContent,
  MultiSelectGroup,
  MultiSelectItem,
  MultiSelectTrigger,
  MultiSelectValue,
} from '@/new/components/shadcn/multi-select';

export function EntityFilters({
  selectedTypes,
  onTypesChange,
  clearAllFilters,
}: {
  selectedTypes: PersonType[];
  onTypesChange: (types: PersonType[]) => void;
  clearAllFilters: () => void;
}) {
  const types = useMemo(() => Object.values(PersonType), []);

  return (
    <FilterPopoverContent clearAllFilters={clearAllFilters}>
      <div>
        <p className="mb-3 text-gray-600">Entity Type</p>
        <MultiSelect values={selectedTypes} onValuesChange={(values) => onTypesChange(values as PersonType[])}>
          <MultiSelectTrigger className="w-full">
            <MultiSelectValue placeholder="Select entity types..." />
          </MultiSelectTrigger>
          <MultiSelectContent>
            <MultiSelectGroup>
              {types.map((type) => (
                <MultiSelectItem key={type} value={type}>
                  {capitalizeFirstLetter(type)}
                </MultiSelectItem>
              ))}
            </MultiSelectGroup>
          </MultiSelectContent>
        </MultiSelect>
      </div>
    </FilterPopoverContent>
  );
}
